function isAdminAssigned(admin, data) {

	if(!data.length) {
		return false;
	}
	
	// set is admin to false
	var isAdmin = false

	// loop thorugh the assigned and see if the admin is there
	$.each(data, function(index, adminData) {
		if(adminData.admin == admin) {
			isAdmin = true;
			return false;
		}
	});

	return isAdmin;
}

function showHideAssigned() {
	if (!$('.assigned-tickets .ticket').length) {
		$('.assigned-tickets').addClass('hidden');
	} else {
		$('.assigned-tickets').removeClass('hidden');
	}
}

channel.bind('process-ticket', function (data) {
	// console.log(data);

	var element;

	// if the ticket is closed or automated, remove it.
	if (data.closed || data.automated) {
		$('.dashboard-tickets .ticket[data-ticket="' + data.ticket + '"]').remove();
		showHideAssigned();
		return;
	}

	// update the current ticket
	if ($('.dashboard-tickets .ticket[data-ticket="' + data.ticket + '"]').length) {
		element = $('.dashboard-tickets .ticket[data-ticket="' + data.ticket + '"]');
		element.attr('data-ticket_assignments', JSON.stringify(data.ticket_assignments));

		element.attr('data-status_parsed', data.status_parsed);
		element.attr('data-status_color', data.status_color);
		element.attr('data-user_full_name', data.user_full_name);
		element.attr('data-user_buyer_id', data.user_buyer_id);
		element.attr('data-user_phone', data.user_phone);
		element.attr('data-user_email', data.user_email);
		element.attr('data-user_avatar', data.user_avatar);

		element.find('[data-input="user_full_name"]').html(data.user_full_name);
		element.find('[data-input="user_buyer_id"]').html(data.user_buyer_id);
		element.find('[data-input="ticket_assignments_parsed"]').html(data.ticket_assignments_parsed);
		element.find('[data-input="total_messages"]').html(data.total_messages);
		element.find('[data-input="total_attachment_messages"]').html(data.total_attachment_messages);
		element.find('[data-input="status_parsed"]').html(data.status_parsed);
		element.find('[data-input="status_parsed"]').attr('data-color', data.status_color);
		element.find('[data-input="automated_status"]').html(data.automated_status);
		element.find('[data-input="date_added"]').html(data.date_added);
		element.find('[data-input="date_added_human"]').html(data.date_added_human);
		element.find('[data-input="date_updated"]').html(data.date_updated);
		element.find('[data-input="date_updated_human"]').html(data.date_updated_human);
	}

	element = $('<div>', {
		class: 'ticket',
		'data-ticket': data.ticket,
		'data-ticket_assignments': JSON.stringify(data.ticket_assignments),
		'data-status_parsed': data.status_parsed,
		'data-status_color': data.status_color,
		'data-user_full_name': data.user_full_name,
		'data-user_buyer_id': data.user_buyer_id,
		'data-user_phone': data.user_phone,
		'data-user_email': data.user_email,
		'data-user_avatar': data.user_avatar
	});

	element.append(`<div class="ticket-header">
		<div class="user-details">
			<h2 data-input="user_full_name">${data.user_full_name}</h2>
			<p><span data-input="user_email">${data.user_email}</span></p>
			<p>
				<span data-input="user_buyer_id">${data.user_buyer_id}</span>
				<span data-input="user_phone">${data.user_phone}</span>
			</p>
		</div>

		<div class="ticket-status-wrapper">
			<span class="ticket-status" data-input="status_parsed" data-color="${data.status_color}">${data.status_parsed}</span>
		</div>
	</div>

	<div class="ticket-details">
		<figure>
			<img data-input="user_avatar" src="${data.user_avatar}" alt="avatar">
		</figure>

		<div class="ticket-stats">
			<ul class="details-list table">
				<li><span>Messages</span> <span class="highlight" data-color="white" data-input="total_messages">${data.total_messages}</span></li>
				<li><span>Files</span> <span class="highlight" data-color="white" data-input="total_attachment_messages">${data.total_attachment_messages}</span></li>
				<li><span>Mode</span> <span class="highlight" data-color="white" data-input="automated_status">${data.automated_status}</span></li>
				<li><span>Admins</span> <span class="highlight" data-color="white" data-input="ticket_assignments_parsed">${data.ticket_assignments_parsed}</li>

				<!-- <li><span>Created</span> <span class="highlight" data-color="white" data-input="date_added">${data.date_added}</span></li>
				<li><span>Updated</span> <span class="highlight" data-color="white" data-input="date_updated">${data.date_updated}</span></li> -->
			</ul>
		</div>
	</div>

	<div class="ticket-controls">
		<a href="" class="button view-ticket-trigger">View</a>
		<a href="admin/ticket/${data.ticket}" class="button">Manage</a>
	</div>`);

	// if exsits and not assigned
	if ($('.assigned-tickets .ticket[data-ticket="' + data.ticket + '"]').length && !isAdminAssigned($('.view-ticket').attr('data-admin'), data.ticket_assignments)) {
		$('.assigned-tickets .ticket[data-ticket="' + data.ticket + '"]').remove();
    }
	
	// if im assigned and not in the list, add it
	if (!$('.assigned-tickets .ticket[data-ticket="' + data.ticket + '"]').length && isAdminAssigned($('.view-ticket').attr('data-admin'), data.ticket_assignments)) {
		element.clone().prependTo('.assigned-tickets .card-details');
	}

	// // if the ticket doesnt exist
	if (!$('.opened-tickets .ticket[data-ticket="' + data.ticket + '"]').length) {
		element.clone().prependTo('.opened-tickets .card-details');
	}

	showHideAssigned();

});